<h3>DE CIFRIS AUGUSTAE TAURINORUM</h3>
<h5>Comitato organizzatore</h5>
<ul>
	<li> Danilo Bazzanella, Politecnico di Torino;</li>
	<li> Lea Terracini, Università di Torino;</li>
	<li> Guglielmo Morgari, Telsy S.p.A.;</li>
	<li> Fabio Fiori, Quadrans.</li>
</ul>

<h4>SEMINARI RECENTI</h4>
<div>
	<p class="warning">Avviso: causa dell'emergenza Coronavirus (Covid-19) organizzeremo i prossimi eventi in webinar.
	</p>
	<li>
		<b>20 Settembre 2022 - 14:30</b>
		<ul>
			<li>
				<b>Veronica Cristiano</b> -- Telsy SpA <br>
				<i>"Cryptographic aspects in WireGuard, a modern VPN protocol"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
							staeTaurinorum/veronicaCristiano.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
							staeTaurinorum/Allegato 1 - Cristiano.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=1nw6TOdYYxA">Video</a>
			</li>
			<li>
				<b> 17 Maggio 2022 - 16:00</b>
				<ul>
					<li>
						<b>Gessica Alecci</b> -- Politecnico di Torino <br>
						<i>"A study on the use of PellHyperbolas in DLP-based crypto systems"</i><br>
						<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/Allegato 1_Alecci_Taurinorum.pdf">Locandina</a> --
						<a href="../../../assets/attivita/seminariLocali/deCifrisAugustae
											Taurinorum/Alellegato2_ Alecci.pdf">Slide</a>
					</li>
				</ul>
			</li>
			<li>
				<b> 15 Marzo 2022</b>
				<ul>
					<li>
						<b>Chiara Marcolla</b> -- Technology Innovation Institute (AE) <br>
						<i>"Searchable Encryption and a practical construction"</i> <br>
						<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/MarcollaLocandina.pdf">Locandina</a> --
						<a href="../../../assets/attivita/seminariLocali/deCifrisAugu
									staeTaurinorum/MarcollaSlide.pdf">Slide</a>
					</li>
				</ul>
			</li>
			<li>
				<b> 18 Gennaio 2022</b>
				<ul>
					<li>
						<b>Javier Verbel</b> -- Technology Innovation Institute (AE) <br>
						<i>"Practical complexities of probabilistic algorithms
							for solving Boolean polynomial systems"</i><br>
						<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/01.2022-Javier Verbel.pdf">Locandina</a> --
						<a href="../../../assets/attivita/seminariLocali/deCifris
									AugustaeTaurinorum/ALLEGATO1_Slide_Verbel.pdf">Slide</a>
						<br>
					</li>
				</ul>
			</li>
		</ul>
	</li>
</div>


<h4>PROSSIMI SEMINARI</h4>
<ul>

</ul>
<h4>SEMINARI PASSATI</h4>
<div>
	<ul>
		<li>
			<b>1 Dicembre 2021</b>
			<ul>
				<li>
					<b>Andrea Gangemi e Alessandro Guggino</b> -- Politecnico di Torino <br>
					<i>"Schnorr and Taproot: an overview of the new Bitcoin update"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifrisAugust
								aeTaurinorum/12.2021-Gangemi-Guggino.pdf">Locandina</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>19 Giugno 2021 - 14:30</b>
			<ul>
				<li>
					<b>Guglielmo Morgari</b> -- Telsy. <br>
					<i>"IOTA and the TANGLE"</i><br>
					<a href="../../../assets/attivita/seminariLocali/deCifrisAugustae
								Taurinorum/MorgariLocandina.pdf">Locandina</a> --
					<a href="https://www.youtube.com/watch?v=TcqHqtTB-fY">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>19 Aprile 2021 - 16:00</b>
			<ul>
				<li>
					<b>Roberto La Scala</b> -- Università di Bari <br>
					<i>Cifrari ed equazioni alle differenze</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/LaScala.pdf">Locandina</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>26 Marzo 2021:</b>
			<ul>
				<li>
					<b>Francesco Stocco</b> -- Telsy S.p.A.<br>
					<i>A theoretical approach to Shor’s Algorithm and Quantum Bits</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Stocco.pdf">Locandina</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>5 Febbraio 2021:</b>
			<ul>
				<li>
					<b>Carlo Sanna</b> -- Politecnico di Torino <br>
					<i>Introduction to Multivariate Cryptography</i><br>
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/locandina_Sanna.pdf">Locandina</a>
					--
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Sanna_Intro_MVC.pdf">Slide</a>
					--
					<a href="https://youtu.be/v5su7blRrHk">Video</a>
					<br>
				</li>
			</ul>
		</li>
		<li><b>17 luglio 2020:</b>
			<ul>
				<li>
					<b>Giordano Santilli</b> -- Università di Trento<br>
					<i>An investigation on Integer Factorization applied to Public Key Cryptography</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/locandina_Gsantilli.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/presentazione_Santilli.pdf">
						Slide</a> --
					<a href="https://youtu.be/3U_DtScwDHU">Video</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>21 maggio 2020:</b>
			<ul>
				<li>
					<b>Michela Ceria</b> -- Università di Milano<br>
					<i>Why you should not even think to use Ore algebras in Cryptography</i><br>
					<a href='./seminari_2020/locandine/taurinorum/05/Ceria2020.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a href="./seminari_2020/slide/taurinorum/05/slideCeria.pdf"> Slide</a> --
					<a href="https://youtu.be/aZZsLD68Yac">Video</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>15 maggio 2020:</b>
			<ul>
				<li>
					<b>Andrea Gangemi</b> -- Politecnico di Torino<br>
					<i>The links between Machine Learning and Blockchain</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Gangemi2020.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/slideGangemi.pdf">Slide</a>
					--
					<a href="https://youtu.be/KDvD5oCz0RY">Video</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>24 aprile 2020:</b>
			<ul>
				<li>
					<b>Barbàra Fadi</b> -- Università di Torino<br>
					<i>An introduction to the Blockchain Privacy Problem</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Barbara2020.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/barbara-slide.pdf">Slide
					</a> -- <a href="https://youtu.be/nPQJ7Cix77k">Video</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>8 aprile 2020:</b>
			<ul>
				<li>
					<b>Francesco Saettone</b> -- Ben-Gurion University of the Negev<br>
					<i>Towards a computational approach for Chabauty method</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/SAETTONE_locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/SAETTONE-slide.pdf">Slide</a>
					--
					<a href="https://youtu.be/WmU63b7gXQw">Video</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>21 febbario 2020:</b>
			<ul>
				<li>
					<b>Maurizio Murgia</b> -- Università di Trento<br>
					<i>Libra blockchain and consensus: an overview</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/MURGIA.locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a>.
					<!-- -- <a href="./seminari_2020/slide/taurinorum/04/SAETTONE-slide.pdf"> Slide</a>.<br> -->
				</li>
			</ul>
		</li>
		<li><b>6 dicembre 2019:</b>
			<ul>
				<li>
					<b>Michele Elia</b> -- Politecnico di Torino<br>
					<i>Continued Fractions and Factoring</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/elia-locandinaTO.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/ELIA-slide">Slide</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>22 novembre 2019:</b>
			<ul>
				<li>
					<b>Stefano Barbero</b> -- Politecnico di Torino<br>
					<i>An overview on cryptanalysis of ARX ciphers</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/barbero-locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/barbero-slide">Slide</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>25 settembre 2019:</b>
			<ul>
				<li>
					<b>Andrea Visconti</b> -- Università di Milano<br>
					<i>Key derivation function: an essential (and usually transparent) component of real-world
						applications</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/visconti-locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/visconti-slide.pdf">Slide</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>15 luglio 2019:</b>
			<ul>
				<li>
					<b>Giuseppe D'Alconzo</b> -- Telsy S.p.A.<br>
					<i>An introduction to Secure Multi-Party Computation</i><br>
					<a
						href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/dalconzo-locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/dalconzo-slide.pdf">Slide</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>16 maggio 2019:</b>
			<ul>
				<li>
					<b>Fabio Fiori</b> -- Fondazione Quadrans<br>
					<i>Distributed consensus algorithm, a novel approach</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/fiori-locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/fiori-slide.pdf">Slide</a>.<br>
				</li>
			</ul>
		</li>
		<li><b>18 aprile 2019:</b>
			<ul>
				<li>
					<b>Simone Dutto</b> -- Politecnico di Torino<br>
					<i>An overview about elliptic curve cryptosystems and pairings</i><br>
					<a href='../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/dutto-locandina.pdf'>
						<font color="#000080">Locandina</font>
					</a> --
					<a
						href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/dutto-slide.pdf">Slide</a>.<br>
				</li>
			</ul>
		</li>
	</ul>
</div>
<!-- <p>
				Il coordinatore dei seminari: Roberto La Scala 
				<a href="mailto:roberto.lascala@uniba.it">roberto.lascala@uniba.it</a>.
			</p>
			<hr> -->